export const createDisqualificationTooltipContent = (
  reason: string | null | undefined,
  callerNote: string | null | undefined
) => {
  if (reason === null && callerNote === null) {
    return null;
  }

  return (
    <>
      {reason && (
        <p className="typography-body-5">
          <b>Reason: </b> {reason}
        </p>
      )}

      {callerNote && (
        <p className="typography-body-5">
          <b>Caller note: </b> {callerNote}
        </p>
      )}
    </>
  );
};
